import { Injectable, signal } from "@angular/core";

import { RiskAssessmentTemplateImportExportData } from "../models";

@Injectable({ providedIn: "root" })
export class RiskAssessmentTemplateImportService {
  private readonly data = signal<RiskAssessmentTemplateImportExportData>(undefined);

  getData() {
    return this.data();
  }

  clearData() {
    this.data.set(undefined);
  }

  async isValid(data: any): Promise<boolean> {
    if (!this.isValidFormat(data)) {
      return false;
    }

    this.data.set(data);

    return true;
  }

  private isValidFormat(data: any): data is RiskAssessmentTemplateImportExportData {
    return (
      typeof data === "object" &&
      data !== null &&
      typeof data.name === "string" &&
      typeof data.description === "string" &&
      Array.isArray(data.indicatorGroups) &&
      data.indicatorGroups.every(
        (group) =>
          typeof group === "object" &&
          group !== null &&
          typeof group.name === "string" &&
          Array.isArray(group.indicators) &&
          group.indicators.every(
            (indicator) =>
              typeof indicator === "object" &&
              indicator !== null &&
              typeof indicator.indicator === "string" &&
              typeof indicator.guidance === "string" &&
              Array.isArray(indicator.mitigations) &&
              indicator.mitigations.every(
                (mitigation) =>
                  typeof mitigation === "object" &&
                  mitigation !== null &&
                  typeof mitigation.name === "string" &&
                  typeof mitigation.description === "string",
              ),
          ),
      )
    );
  }
}
